module.exports = __webpack_public_path__ + "static/media/sample.caa72261.pdf";